import { render, staticRenderFns } from "./sso-acknowledgement-modal.vue?vue&type=template&id=4a16caec&"
import script from "./sso-acknowledgement-modal.vue?vue&type=script&lang=js&"
export * from "./sso-acknowledgement-modal.vue?vue&type=script&lang=js&"
import style0 from "./sso-acknowledgement-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sso-acknowledgement-modal.vue"
export default component.exports